/* eslint-disable @next/next/no-img-element */
import HeadingServices from '../HeadingServices';
import HeadingTitle from '../HeadingTitle';

export default function DomainConsult({ datasDomain }) {
    return (
        <div>
            <HeadingServices title={datasDomain.upperTitle} lowerTitle={datasDomain.documentTitle} />
            <div className="container my-3 my-lg-5">
                <div className="row">
                    <div className="col">
                        <p className="text-5 line-height-2 text-dark">
                            <strong className="font-weight-extra-bold text-dark"> {datasDomain.paragrafTitleOne}</strong>
                            {datasDomain.paragrafOne}
                        </p>
                        <div className="float-left img-fluid img-small-width mr-md-3 my-1">
                            <img
                                width="100%"
                                height="100%"
                                src="/images/consult/domain.png"
                                alt="domain"
                            />
                        </div>
                        <p className="text-5 line-height-2 text-dark">
                            <strong className="font-weight-extra-bold text-dark"> {datasDomain.paragrafTitleTwo}</strong>
                            {datasDomain.paragrafTwo}
                        </p>
                        <p className="text-5 line-height-2 text-dark">
                            <strong className="font-weight-extra-bold text-dark"> {datasDomain.paragrafTitleThree}</strong>
                            {datasDomain.paragrafThree}
                        </p>
                        <p className="text-5 line-height-2 text-dark ">
                            <strong className="font-weight-extra-bold text-dark"> {datasDomain.paragrafTitleFour}</strong>
                            {datasDomain.paragrafFour}
                        </p>
                        <p className="text-5 mb-lg-5 line-height-2 text-dark">
                            <strong className="font-weight-extra-bold text-dark"> {datasDomain.paragrafTitleFive}</strong>
                            {datasDomain.paragrafFive}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
